import React from 'react';
import { Paper, Typography, Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import PersonIcon from '@material-ui/icons/Person';

import ScheduleForm from './Forms/ScheduleForm';
import BankOfHoursForm from './Forms/BankOfHoursForm';
import RestrictionsForm from './Forms/RestrictionsForm';

import { fetchSchedules } from '../../../store/actions/schedule';
import { fetchLocations } from '../../../store/actions/location';
import { createNewEmployee } from '../../../store/actions/employee';
import { compare } from './Helpers/compareValues';

import IconButton from '@material-ui/core/IconButton';
import Add from '@material-ui/icons/AddCircleOutline';
import CreateSchedule from '../../Schedules/CreateSchedule';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { fetchEmployee, fetchEmployeeConfigs } from '../../../store/actions/employee';
import moment from 'moment';
import Star from '@material-ui/icons/Star';
import { usageLog } from '../../../store/actions/globalActions';
import { ModalFirstEmployee } from './ModalFirstEmployee';

function ConfigStep(props) {
  const {
    configValues,
    setConfigValues,
    setAllowReturn,
    defaultValues,
    employeeId,
    handleNewHasBlockedDevice,
    state
  } = props;

  const dispatch = useDispatch();
  const schedules = useSelector(state => state.schedule.schedules);
  const locations = useSelector(state => state.location.locations);
  const [premium] = React.useState(JSON.parse(localStorage.getItem('privileges')).isExportAfd);

  const [returning, setReturning] = React.useState(false);
  const [scheduleFormValues, setScheduleFormValues] = React.useState({});
  const [bankOfHoursFormValues, setBankOfHoursFormValues] = React.useState({});
  const [restrictionsForm, setRestrictionsForm] = React.useState({});
  const [formsStatus, setFormsStatus] = React.useState({ schedule: false, bankOfHours: false, restrictions: false });
  const [submit, setSubmit] = React.useState({ event: null, toggle: false });

  const [restrictionsIsValid, setRestrictionsIsValid] = React.useState(true);
  const [bankOfHoursIsValid, setBankOfHoursIsValid] = React.useState(true);
  const [scheduleIsValid, setScheduleIsValid] = React.useState(true);

  const [scheduleModal, setScheduleModal] = React.useState(false);
  const [firstUpdate, setfirstUpdate] = React.useState(true);
  const [sending, setSending] = React.useState(false);
  const [hasBlockedDevice, setHasBlockedDevice] = React.useState({});
  const [device, setDevice] = React.useState(false);


  React.useEffect(() => {
    setConfigValues({
      ScheduleForm: scheduleFormValues,
      BankOfHoursForm: bankOfHoursFormValues,
      RestrictionsForm: restrictionsForm,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleFormValues, restrictionsForm, bankOfHoursFormValues]);



  React.useEffect(() => {
    if (firstUpdate) {
      dispatch(fetchSchedules());
      dispatch(fetchLocations());
      setfirstUpdate(false);
    }
  });
  let BlockedDevice = {}
  // const hasBlockedDevice = BlockedDevice


  const DeviceBlocked = async () => {
    dispatch(await fetchEmployeeConfigs(employeeId))
      .then((response) => {
        BlockedDevice.hasBlockedDevice = response.restrictions.hasBlockedDevice
        BlockedDevice.hasRestrictDevice = response.restrictions.hasRestrictDevice
        BlockedDevice.listBlockedDevice = response.restrictions.listBlockedDevice
        // console.log('value', hasBlockedDevice)
      })
  }

  React.useEffect(() => {
    if (employeeId && device == false) {
      DeviceBlocked()
      setDevice(true)
      setHasBlockedDevice(BlockedDevice)
    }
    // console.log('device', device)
  })

  React.useEffect(() => {
    if (returning) {
      setAllowReturn(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [returning]);

  const formatMinutes = (string) => {
    if (string && string.length) {
      let hours = '';
      let minutes = '';
      const separator = string.indexOf(':');
      let sign = 1;
      if (string.indexOf('-') === 0) {
        hours = string.slice(1, separator);
        sign = -1;
      } else {
        hours = string.slice(0, separator);
      }

      minutes = string.slice(separator + 1);
      return (parseInt((hours * 60), 10) + parseInt(minutes, 10)) * sign;
    }
    return 0;
  };

  const formatNewEmployee = (employee, configs) => {
    const data = {
      newEmployee: { ...employee },
      bankHours: {
        initialValue: configs.BankOfHoursForm.initialValue,
        dtFrom: configs.BankOfHoursForm.dtFrom,
        dtTo: configs.BankOfHoursForm.dtTo,
        disableCurrent: false,
        hasBankOfHours: configs.BankOfHoursForm.hasBankOfHours,
        cumulativeHoursLimit: configs.BankOfHoursForm.cumulativeHoursLimit
      },
      restrictions: {
        dtRef: moment(configs.RestrictionsForm.dtRef).format('YYYY-MM-DD') == 'Data inválida' ? moment(new Date()).format('YYYY-MM-DD') : moment(configs.RestrictionsForm.dtRef).format('YYYY-MM-DD'),
        hasPhoto: configs.RestrictionsForm.hasPhoto,
        restrictByLocation: configs.RestrictionsForm.restrictByLocation,
        hasBlockedDevice: state.newHasBlockedDevice == '' ? null : state.newHasBlockedDevice
      },
      allowedLocations: configs.RestrictionsForm.locations,
      workSchedule: {
        dtRef: configs.ScheduleForm.scheduleStartDate && format(configs.ScheduleForm.scheduleStartDate, 'yyyy-MM-dd'),
        workScale: configs.ScheduleForm.scheduleId,
      },
    };

    const newEmployee = {};
    newEmployee.employee = { ...data.newEmployee };
    newEmployee.workSchedule = { ...data.workSchedule };

    if (data.restrictions.hasPhoto || data.restrictions.restrictByLocation || data.restrictions.hasBlockedDevice) {
      newEmployee.restrictions = { ...data.restrictions };
    }

    if (data.allowedLocations.length) {
      newEmployee.allowedLocations = [...data.allowedLocations];
    }

    if (data.bankHours.hasBankOfHours) {
      newEmployee.bankHours = {
        initialValue: formatMinutes(data.bankHours.initialValue),
        dtFrom: format(data.bankHours.dtFrom, 'yyyy-MM-dd'),
        dtTo: format(data.bankHours.dtTo, 'yyyy-MM-dd'),
        disableCurrent: false,
        cumulativeHoursLimit: data.bankHours.cumulativeHoursLimit
      };
    }
    if (employeeId) {
      const result = compare(defaultValues, newEmployee);
      const editedEmployee = {};
      editedEmployee.employee = { ...employee, id: parseInt(employeeId, 10) };

      if (!result.schedule) {
        editedEmployee.workSchedule = { ...newEmployee.workSchedule };
      }

      if (!result.bank) {
        editedEmployee.bankHours = (
          Object.entries({ ...newEmployee.bankHours }).length === 0 && { ...newEmployee.bankHours }.constructor === Object
        ) ? { disableCurrent: true } : { ...newEmployee.bankHours };
      }

      if (!result.restrictions) {
        if (newEmployee.restrictions === undefined) {
          editedEmployee.restrictions = { ...data.restrictions };
        } else {
          editedEmployee.restrictions = { ...newEmployee.restrictions };
        }
        if (newEmployee.restrictions && newEmployee.restrictions.restrictByLocation) {
          editedEmployee.allowedLocations = [...newEmployee.allowedLocations];
        }
      }

      dispatch(createNewEmployee(editedEmployee, 'Atualização realizada com sucesso'))
        .then(() => {
          setSending(false);
          props.history.push('/funcionarios');
        })
        .catch(() => {
          setSending(false);
        });
    } else {
      dispatch(createNewEmployee(newEmployee))
        .then(() => {
          setSending(false);
          let url = new URL(window.location.href.toString());
          let type = url.searchParams.get("type");
          if (type == "bemvindo") {
            props.history.push(`/funcionarios?isFirst=true&phone=${props.employeeValues.phone}`);
            return;
          }
          props.history.push('/funcionarios');
        })
        .catch(() => {
          setSending(false);
        });
    }
  };



  const firstRun = React.useRef(true);
  React.useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
    } else if (scheduleIsValid && bankOfHoursIsValid && restrictionsIsValid && formsStatus.schedule && formsStatus.bankOfHours && formsStatus.restrictions) {
      if (!sending) {
        setSending(true);
        formatNewEmployee(props.employeeValues, configValues);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formsStatus]);


  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '24px',
          marginLeft: '5px',
        }}
      >
        <PersonIcon
          style={{
            backgroundColor: '#537ccd',
            color: 'white',
            borderRadius: '50%',
            fontSize: '34px',
            padding: '4px',
          }}
        />
        <span style={{ marginRight: 'auto', marginLeft: '10px' }}>{props.employeeValues.name}</span>
      </div>

      <Paper elevation={2} style={{ padding: '10px', margin: '10px 0px', display: 'flex' }}>
        <Typography variant="body1" style={{ position: 'absolute' }}>
          Escala de trabalho
        </Typography>

        <ScheduleForm
          data={configValues.ScheduleForm}
          loading={false}
          title="Cadastrar"
          schedules={schedules || []}
          returning={returning}
          setReturning={value => setReturning(value)}
          formValues={(values) => {
            setScheduleFormValues(values);
          }}
          submit={submit}
          setSubmit={setSubmit}
          formsStatus={formsStatus}
          setFormsStatus={setFormsStatus}
          setScheduleIsValid={setScheduleIsValid}
        />
        <IconButton
          aria-label="Adicionar Escala"
          component="span"
          onClick={() => setScheduleModal(true)}
          style={{ color: '#537CCD', padding: '6px', marginTop: ' 27px' }}
        >
          <Add />
        </IconButton>
      </Paper>

      <Paper elevation={2} style={{ padding: '10px', margin: '30px 0px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center'
          }}>
          <Typography variant="body1">
            Banco de Horas
          </Typography>
          {!premium ? <Star style={{ color: '#f2b002' }} /> : ''}
        </div>
        <BankOfHoursForm
          data={configValues.BankOfHoursForm}
          UpdateEmployee={() => { }}
          loading={false}
          departments={[]}
          offices={[]}
          title="Cadastrar"
          returning={returning}
          setReturning={value => setReturning(value)}
          formValues={values => setBankOfHoursFormValues(values)}
          submit={submit}
          setSubmit={setSubmit}
          formsStatus={formsStatus}
          setFormsStatus={setFormsStatus}
          setBankOfHoursIsValid={setBankOfHoursIsValid}
        />
      </Paper>

      <Paper elevation={2} style={{ padding: '10px', margin: '10px 0px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center'
          }}>
          <Typography variant="body1">
            Restrições
          </Typography>
          {!premium ? <Star style={{ color: '#f2b002' }} /> : ''}
        </div>
        <RestrictionsForm
          data={configValues.RestrictionsForm}
          hasBlockedDevice={hasBlockedDevice}
          handleNewHasBlockedDevice={handleNewHasBlockedDevice}
          loading={false}
          title="Cadastrar"
          locations={locations || []}
          returning={returning}
          setReturning={value => setReturning(value)}
          formValues={values => setRestrictionsForm(values)}
          submit={submit}
          setSubmit={setSubmit}
          formsStatus={formsStatus}
          setFormsStatus={setFormsStatus}
          setRestrictionsIsValid={setRestrictionsIsValid}
        />
      </Paper>

      <div style={{ display: 'flex', marginTop: '30px' }}>
        <Button
          onClick={() => {
            setReturning(true);
          }}
          style={{ marginLeft: 'auto' }}
        >
          VOLTAR
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ margin: 'unset' }}
          onClick={(e) => {
            setSubmit({ event: e, toggle: true });
            let url = new URL(window.location.href.toString());
            let type = url.searchParams.get("type");
            if (type == "bemvindo") {
              const jwt = require('jsonwebtoken');
              const decodedToken = jwt.decode(localStorage.token);
              usageLog('bemvindo/login/funcionarioCadastrado', decodedToken.companyId, decodedToken.id)
            }
          }}
        >
          {employeeId ? 'ATUALIZAR' : 'CADASTRAR'}
        </Button>
      </div>

      <Dialog open={scheduleModal} onClose={() => { setScheduleModal(false); setfirstUpdate(true); }}>
        <DialogTitle>{'Escala'}</DialogTitle>
        <DialogContent>
          <CreateSchedule FromEmployeeRegister={true} />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => { setScheduleModal(false); setfirstUpdate(true); }}
            style={{ marginLeft: 'auto' }}
          >
            FECHAR
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ConfigStep;
